var exports = {
  "kL": "container__1NpAJt",
  "I6": "inputWrapper__zF_gyB",
  "xu": "inputWrapperWithToolbar__NDrAQV",
  "yB": "shellMode__NARCbR",
  "hF": "input__ct64Yy",
  "az": "inputWithToolbar__YdiWgS",
  "jo": "sendButton__nymypc",
  "e9": "sendButtonGroup___ToG2w",
  "KE": "toolbar__mmwJB3",
  "R5": "toolbarGroup__gE8R3Z",
  "s3": "shellModeLabel__xk_8c3",
  "Of": "submitWithDivider__2-Tqvd",
  "mO": "submitActions__jLICYz",
  "zl": "skeletonWrapper__j2FIhd",
};

module.exports = exports;
